<template>
	<div>
		<div v-if="teams">
			<h3 v-if="teams.length > 0 ">Sneak Peek of {{ teams[0].name }}</h3>
			<div class="row">
				<div class="col-md-6">
					<p class="readable-text">
						During the last 30 days you had
					</p>
					<ul>
						<li><span class="number-s">{{ teams[0].reviews_total_count }}</span> Total Reviews</li>
						<li><span class="number-s">{{ teams[0].ratings_total_average }}</span> Average Rating</li>
					</ul>
					<p class="readable-text">Review sources</p>
					<div class="d-flex justify-content-center flex-wrap align-items-center">
						<img :src="'/img/reviews/' + source + '.png'" class="rating-type-image mr-2 mb-2" v-for="(s, source) in teams[0].ratings_by_source" />
					</div>
				</div>
				<div class="col-md-6" v-if="teams.length > 1">
					<p class="readable-text">
						Competitors included in Trial
					</p>
					<ul>
						<li v-for="(team, index) in teams" v-if="index != 0">{{ team.name }}</li>
					</ul>
				</div>
			</div>
		</div>
		<div v-else>
			<p class="readable-text">Preparing your preview..</p>
		</div>
	</div>
</template>

<script>
export default {
	props: ['team_id'],
	data() {
		return {
			teams: null
		}
	},
	mounted() {
		this.fetchTeamData()
	},
	methods: {
		fetchTeamData() {
			var queryDict = {}
			location.search.substr(1).split("&").forEach(function(item) {queryDict[item.split("=")[0]] = item.split("=")[1]})

			let str = '?fromDate=' + moment().subtract(30, 'days').format("YYYY-MM-DD")
				+ '&toDate=' + moment().format("YYYY-MM-DD") + '&invitation=' + queryDict.invitation
			axios.get(`/api/temp/overview` + str)
			.then(response => {
				this.teams = response.data.competitors
			})
		}
	}
}
</script>